import { render } from "./GenreEditing.vue?vue&type=template&id=7aa270e3"
import script from "./GenreEditing.vue?vue&type=script&lang=js"
export * from "./GenreEditing.vue?vue&type=script&lang=js"
script.render = render

export default script